import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import {
  getGetTipiDocumentoIdTemplateFinaleQueryOptions,
  getGetTipiDocumentoIdTemplateIntermedioQueryOptions,
} from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import { useAuthDownload } from '@framework/common-web';
import { useTranslation } from '@framework/i18n';
import { VerticalSpace } from '@framework/ui';
import { Button, message } from 'antd';
import React from 'react';
import { useHasDocumentsInlineViewer } from '../../../ui/documents/useHasDocumentsInlineViewer';

type GetFileHook =
  | typeof getGetTipiDocumentoIdTemplateIntermedioQueryOptions
  | typeof getGetTipiDocumentoIdTemplateFinaleQueryOptions;

interface Props {
  documentId?: string | null;
  filename?: string | null;
  getQueryOptions: GetFileHook;
}

export function DownloadFileButton(props: Props) {
  const { documentId, filename, getQueryOptions } = props;
  const { t } = useTranslation();
  const hasInlineViewer = useHasDocumentsInlineViewer();

  const { download, isFetching } = useAuthDownload(
    getQueryOptions,
    [documentId ?? ''],
    {
      filename,
      onError: (e: any) => {
        message.error(getNetworkErrorMessage(e, t("download-file-button.error-download-file", 'Si è verificato un problema durante il download del file'))); // prettier-ignore
      },
      showInlineViewer: hasInlineViewer,
    },
  );

  return (
    <>
      <VerticalSpace size={6} />
      <Button
        onClick={download}
        disabled={!documentId || !filename}
        loading={isFetching}
        block
        size="large"
        icon={!hasInlineViewer ? <DownloadOutlined /> : <EyeOutlined />}
      />
    </>
  );
}
